import React, { Component } from "react";
import { BiFilter, BiTrash, BiTrashAlt, BiX } from "react-icons/bi";
import { connect } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  ModalFooter,
  Popover,
  PopoverBody,
} from "reactstrap";
import AssigneeComponent from "../../../components/FilterRowComponents/AssigneeComponent";
import BooleanSelectComponent from "../../../components/FilterRowComponents/BooleanSelectComponent";
import {
  MAIN_ROW_FILTER_TYPES,
  METRICS_FILTER_TYPES,
} from "../../../components/FilterRowComponents/data";
import DateComponent from "../../../components/FilterRowComponents/DateComponent";
import InputComponent from "../../../components/FilterRowComponents/InputComponent";
import LocationSearchComponent from "../../../components/FilterRowComponents/LocationSearchComponent";
import PriorityComponentFilter from "../../../components/FilterRowComponents/PriorityComponent";
import PrivacyStatusComponent from "../../../components/FilterRowComponents/PrivacyStatusComponent";
import ProgressComponent from "../../../components/FilterRowComponents/ProgressComponent";
import SelectFilterOnComponent from "../../../components/FilterRowComponents/SelectFilterOnComponent";
import StatusComponent from "../../../components/FilterRowComponents/StatusComponent";
import * as actionCreators from "../../../modules/actions/index";

export default class MetricsFilterComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filtersArray: [],
      popoverOpen: false,
      filterLength: 0,
    };
  }

  toggle = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.filterParams) !==
      JSON.stringify(nextProps.filterParams)
    ) {
      const filters = nextProps.filterParams.filtersDoc;
      if (filters) {
        const filtersToArray = this.convertToFilterArray(filters);

        this.setState({
          filterLength: filtersToArray.length,
        });
      }
    }
  }

  componentDidMount() {
    const { filterParams, updateFilterParams } = this.props;
    if (filterParams.filtersDoc) {
      const filtersArr = this.convertToFilterArray(filterParams.filtersDoc);
      this.setState({
        filtersArray: filtersArr,
        filterLength: filtersArr.length,
      });
    } else {
      updateFilterParams({ ...filterParams, filtersDoc: {} });
    }
  }

  addNewFilter = () => {
    this.setState({
      filtersArray: [...this.state.filtersArray, { booleanParameter: true }],
    });
  };

  handleRowDataChange = (index, value, key) => {
    const arr = [...this.state.filtersArray];
    const item = arr[index];
    item[key] = value;
    arr[index] = item;
    this.setState({ filtersArray: [...arr] });
  };

  deleteRowItem = (index) => {
    const arr = [...this.state.filtersArray];
    arr.splice(index, 1);
    this.setState({ filtersArray: [...arr] });
  };

  clearFilters = () => {
    this.setState({ filtersArray: [] });
    const doc = {};

    const { filterParams } = this.props;
    this.props.updateFilterParams({
      filtersDoc: doc,
    });
    this.toggle();
  };

  applyFilters = () => {
    const filterObject = this.convertToFilterObject();
    console.log(filterObject);
    this.props.updateFilterParams({
      filtersDoc: filterObject,
    });
    this.toggle()
  };

  convertToFilterObject = () => {
    const arr = [...this.state.filtersArray];
    let filterObject = {};

    const { filterParams } = this.props;
    
    if (filterParams && filterParams.filtersDoc.title) {
      console.log("first");
      filterObject.title = filterParams.filtersDoc.title;
    }

    arr.forEach((ele) => {
      if (ele.filterOn === "NAME") {
        filterObject.name = {
          value: ele.name, //type - string
          equalsOrIncludes: ele.booleanParameter,
        };
      } else if (ele.filterOn === "CREATED_ON") {
        filterObject.createdOn = {
          value: ele.createdOn, //type -string or array
          equalsOrIncludes: ele.booleanParameter,
        };
      }else if (ele.filterOn === "CREATED_BY") {
        filterObject.groupOwner = {
          value: ele.groupOwner, //type number
          equalsOrIncludes: ele.booleanParameter,
        };
      } 
      else if (ele.filterOn === "LOCATION") {
        filterObject.location = {
          value: ele.location, //type number
          equalsOrIncludes: ele.booleanParameter,
        };
      } 
    });

    return filterObject;
  };

  convertToFilterArray = (object) => {
    let filterObject = { ...object };
    let filtersArr = [];
    for (const key in filterObject) {
      if (Object.hasOwnProperty.call(object, key)) {
        const ele = object[key];

        if (key === "name") {
          filtersArr.push({
            filterOn: "NAME",
            status: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } else if (key === "createdOn") {
          filtersArr.push({
            filterOn: "CREATED_ON",
            createdOn: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        }
        else if (key === "groupOwner") {
          filtersArr.push({
            filterOn: "CREATED_BY",
            groupOwner: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } 
        else if (key === "location") {
          filtersArr.push({
            filterOn: "LOCATION",
            location: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } 
      }
    }

    return filtersArr;
  };

  render() {
    const { filtersArray, filterLength } = this.state;
    console.log(filtersArray)
    return (
      <div>
        <div
          className="action-table-filter-btn btn"
          style={{ height: "38px" }}
          onClick={this.toggle}
        >
          <span>Filters</span>
          <BiFilter className="cursor-pointer" fontSize={"26px"} id="Modal1" />
          {filterLength > 0 ? (
            <span className="actions-filter-counter">{filterLength}</span>
          ) : (
            ""
          )}
        </div>

        <Popover
          isOpen={this.state.popoverOpen}
          target="Modal1"
          toggle={this.toggle}
          placement="bottom"
          className="action-filters-popover"
        >
          <PopoverBody className={"action-filters-popover-body"}>
            <div className="action-filters-header-div">
              <h5>Filters</h5>

              <BiX fontSize="26px" onClick={this.toggle} />
            </div>

            <div className="filters-row-div my-3">
              {filtersArray.map((item, index) => {
                return (
                  <div className="action-filter-row-item my-2">
                    <span>WHERE</span>
                    <SelectFilterOnComponent
                      item={item}
                      onDataChange={this.handleRowDataChange}
                      index={index}
                      options={METRICS_FILTER_TYPES}
                    />

                    {
                      item.filterOn !== "LOCATION" && item.filterOn !== "NAME" &&    <BooleanSelectComponent
                      item={item}
                      onDataChange={this.handleRowDataChange}
                      index={index}
                    />
                    }
                 

                    {item.filterOn === "CREATED_ON" ? (
                      <DateComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                        dKey="createdOn"
                      />
                    ) : item.filterOn === "NAME" ? (
                      <InputComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                        dKey="name"
                      />
                    ) : item.filterOn === "CREATED_BY" ? (
                      <AssigneeComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                        dKey="groupOwner"
                      />
                    ) : item.filterOn === "LOCATION" ? (
                      <LocationSearchComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                        dKey="location"
                      />
                    ) :""}

                    <div style={{ marginLeft: "auto" }}>
                      <BiTrash
                        size={"22px"}
                        className="cursor-pointer"
                        onClick={() => this.deleteRowItem(index)}
                        color="gray"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="my-2">
              <Button size="sm" onClick={this.addNewFilter}>
                {" "}
                + Add Filter{" "}
              </Button>
            </div>
          </PopoverBody>

          <ModalFooter>
            <Button color="primary" onClick={this.applyFilters}>
              Apply Filters
            </Button>
            <Button onClick={() => this.clearFilters()}>Clear</Button>
          </ModalFooter>
        </Popover>
      </div>
    );
  }
}
